import { Component } from '@angular/core';
import { getYearOptions, monthOptions } from '../../../utils/helpers';
import { EmployeeLocalService } from '../../services/employee.service';
import { CompanyService } from '../../../services/company.service';
import { ModalRejectComponent } from '../../../shared/modals/modal-reject/modal-reject.component';
import { IComboBase } from '../../../interfaces/base/base.interface';
import { DialogService } from 'primeng/dynamicdialog';
import { Router } from '@angular/router';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-cesados',
  templateUrl: './cesados.component.html',
  styleUrl: './cesados.component.scss'
})
export class CesadosComponent {
  dataSource: any[] = [];
  mostrar: boolean = false;
  dataToEdit: any = null;

  mostrarModalEditar: boolean = false;
  mostrarModalDetalle: boolean = false;

  dataDetail: any = null;
  dataDetailContract: any = null;

  contractId: number = 0;

  // MES 
  monthOptions: IComboBase[] = [{ key: '00', text: 'Todos' }, ...monthOptions];
  currentMonth: IComboBase | null = null;
  selectedMonth: IComboBase | null = null;
  
  // AÑO
  yearOptions: IComboBase[] = [];
  selectedYear: IComboBase | null = null;
  
  isLoading: boolean = true;
  pageIndex: number = 0;
  pageSize: number = 10;
  totalElements: number = 0;
  
  searchTerm = '';
  userData: any = null;

  selectedRowId: number | null = null;

  headerClasses: { 
    [key: string]: string 
  } = {
    '1': 'header-keola',
    '2': 'header-inresort',
    '3': 'header-inclub',
    '4': 'header-ribera',
    '5': 'header-keolafood',
    '6': 'header-valle',
  };

  currentHeaderClass: string = 'header-keola';

  mostrarModalContrato: boolean = false;
  employeeDataContract: any = null;

  constructor(
    private employeeLocalService: EmployeeLocalService,
    private companyService: CompanyService,
    private router: Router
  ) {
    this.currentMonth = this.monthOptions[0];
    this.selectedMonth = { key: '00', text: 'Todos' };

    this.yearOptions = getYearOptions();
    this.selectedYear = this.yearOptions.find((y) => y.key === new Date().getFullYear().toString()) || null;
  }

  tabs: IComboBase[] = [];
  selectedTabKey: string | null = null;

  displayedColumns = [
    { key: 'employeeName', header: 'Empleado' },
    { key: 'jobPositionName', header: 'Cargo' },
    { key: 'salary', header: 'Sueldo' },
    { key: 'startDateContract', header: 'F. Inicio' },
    { key: 'endDate', header: 'F. Fin' },
    { key: 'terminationDate', header: 'F. Cese' },
    { key: 'fileContract', header: 'Contrato' },
  ];

  actionButtons = [
    {
      icon: 'pi pi-eye',
      color: '#ED672A',
      tooltip: 'Ver',
      action: (row: any) => {
        this.dataDetail = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalDetalle = true;
      },
      visible: (row: any) => true,
    },
    {
      icon: 'pi pi-pen-to-square',
      color: '#ED672A',
      tooltip: 'Editar',
      action: (row: any) => {
        this.dataToEdit = {
          ...row,
          empresa: this.tabs.find((tab) => tab.key === this.selectedTabKey),
        };
        this.mostrarModalEditar = true;
      },
      visible: (row: any) => true,
    },
  ];

  ngOnInit(): void {
    const userDataString = localStorage.getItem('access');
    if (userDataString) {
      this.userData = JSON.parse(userDataString);
    }
    this.companyService.comboCompany().subscribe({
      next: (data) => {
        this.tabs = data;
        this.selectedTabKey = this.tabs[0].key;
        this.onTabSelected(this.selectedTabKey);
      },
      error: (err) => {
        console.error('Error al obtener la lista de empresas:', err);
        this.filterData();
      },
    });
  }

  onOpenContractModal(data: any): void {
    this.employeeDataContract = data;
    this.mostrarModalContrato = true;
  }

  onDialogContractClose(): void {
    this.mostrarModalContrato = false;
    this.employeeDataContract = null;
  }

  onBackToEditModal(): void {
    this.mostrarModalContrato = false;
    this.mostrarModalEditar = true;
  }

  onRegisterComplete(): void {
    this.filterData();
  }

  onDialogClose() {
    this.mostrar = false;
  }

  onDialogDetailClose() {
    this.mostrarModalDetalle = false;
    this.dataDetail = null;
  }

  onMonthChange(selected: IComboBase): void {
    this.selectedMonth = selected;
    this.filterData(true);
  }

  onYearChange(selected: IComboBase): void {
    this.selectedYear = selected;
    this.filterData(true);
  }

  onSearch(query: string): void {
    this.searchTerm = query;
    this.filterData(true);
  }

  filterData(resetPage: boolean = false): void {
    if (resetPage) {
      this.pageIndex = 0;
    }

    this.isLoading = true;

    const filters = {
      search: this.searchTerm || null,
      month: this.selectedMonth?.key == '00' ? null : this.selectedMonth?.key,
      year: this.selectedYear?.key || null,
      companyId: this.selectedTabKey || null,
      employeeState: false,
      page: this.pageIndex,
      size: this.pageSize,
    };

    this.employeeLocalService.postContractByCompany(filters).subscribe({
      next: (response) => {
        this.dataSource = response.content;
        this.pageIndex = response.page.page;
        this.pageSize = response.page.size;
        this.totalElements = response.page.totalElements;
        this.isLoading = false;
      },
      error: (err: any) => {
        this.isLoading = false;
        console.error('Error al obtener los datos:', err);
      },
    });
  }

  onTabSelected(tabKey: string): void {
    this.selectedTabKey = tabKey;
    this.currentHeaderClass = this.headerClasses[tabKey] || 'header-keola';
    this.filterData(true);
  }

  onPageChange(event: PageEvent): void {
    this.pageIndex = event.pageIndex;
    this.pageSize = event.pageSize;
    this.filterData();
  }

  onRowSelected(row: any): void {
    this.selectedRowId = row.contractId;
  }

  onEditComplete(): void {
    this.filterData();
  }

  formatDate(dateString: string): string {
    if (!dateString) return '';

    const monthsMap: { [key: string]: string } = {
      January: '01',
      February: '02',
      March: '03',
      April: '04',
      May: '05',
      June: '06',
      July: '07',
      August: '08',
      September: '09',
      October: '10',
      November: '11',
      December: '12',
    };

    const dateParts = dateString.match(/(\w+)\s(\d+)\sdel\s(\d+)/);
    if (!dateParts) return dateString;

    const month = monthsMap[dateParts[1]];
    const day = dateParts[2].padStart(2, '0');
    const year = dateParts[3].slice(-2);

    return `${day}/${month}/${year}`;
  }

  extractFileName(fileUrl: string): string {
    const lastDashIndex = fileUrl.lastIndexOf('-', fileUrl.lastIndexOf('.'));
    const fileName = fileUrl.substring(lastDashIndex + 1);
    return fileName;
  }

  onDetail(row: any) {
    this.dataDetailContract = row;
    this.router.navigate([
      `/dashboard/employee/cesados/detail/${row.employeeId}`,
    ]);
  }
}
